import React, { useRef } from 'react';
import { Pressable, StyleSheet } from 'react-native';
import {
  BodyText,
  FadeView,
  LoadingDots,
  theme,
  usePressableState,
} from '@sweetgreen/garnish';

import {
  useKustomerAvailability,
  useKustomerContactUsHandler,
} from '../../../integrations/kustomer';
import type { useOrganizationLinksFooterContentfulData } from '../hooks';
import { OrganizationLinksFooterLink } from './OrganizationLinksFooterLink';

export const OrganizationLinksFooterLinkKustomer = (props: LinkProps) => {
  const { link } = props;

  const contactUsRef = useRef(null);
  const contactUsPressableState = usePressableState(contactUsRef);

  const isKustomerAvailable = useKustomerAvailability();
  const { handlingContactUs, handleContactUs } = useKustomerContactUsHandler(
    isKustomerAvailable,
    'org-links',
  );

  if (isKustomerAvailable) {
    return (
      <Pressable
        accessibilityRole="button"
        ref={contactUsRef}
        style={styles.label}
        onPress={handleContactUs}
      >
        <BodyText underline={contactUsPressableState.isHovered}>
          {link.label}
        </BodyText>
        <FadeView show={handlingContactUs} style={styles.loading}>
          <LoadingDots />
        </FadeView>
      </Pressable>
    );
  }

  return <OrganizationLinksFooterLink link={link} />;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type LinkProps = Readonly<{
  link: ReturnType<
    typeof useOrganizationLinksFooterContentfulData
  >['contentfulFooter']['sections'][0]['links'][0];
}>;

// ─── Styles ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  label: {
    flexDirection: 'row',
    marginBottom: theme.spacing['1'],
  },
  loading: {
    marginLeft: theme.spacing['2'],
  },
});
